import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Header } from '../components/layout/Header';
import { 
  CheckCircle,
  XCircle,
  Spinner
} from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function VerifyCertificate() {
  const { code } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyCertificate();
  }, [code]);

  const verifyCertificate = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/certificates/verify/${code}`);
      setResult(response.data);
    } catch (error) {
      setResult({ valid: false });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8F9FA]">
        <Header />
        <div className="flex justify-center py-20">
          <Spinner size={48} className="animate-spin text-[#2C3E50]" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <Header />
      
      <div className="max-w-xl mx-auto px-6 py-12" data-testid="verify-page">
        <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-8 text-center">
          {result?.valid ? (
            <>
              <div className="w-20 h-20 rounded-full bg-[#27AE60] flex items-center justify-center mx-auto mb-6">
                <CheckCircle size={48} weight="fill" className="text-white" />
              </div>
              <h1 className="text-2xl font-bold text-[#27AE60] mb-4">Certificado Verificado</h1>
              <p className="text-[#5C6B7A] mb-6">Este certificado é autêntico e foi emitido pelo Aprenda Tecnoservice.</p>
              
              <div className="bg-[#F8F9FA] rounded-lg p-6 text-left">
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-[#5C6B7A]">Nome</p>
                    <p className="font-semibold text-[#1A252F]">{result.certificate.user_name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-[#5C6B7A]">Curso</p>
                    <p className="font-semibold text-[#1A252F]">{result.certificate.course_title}</p>
                  </div>
                  <div>
                    <p className="text-sm text-[#5C6B7A]">Data de Emissão</p>
                    <p className="font-semibold text-[#1A252F]">
                      {new Date(result.certificate.issued_at).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="w-20 h-20 rounded-full bg-[#E74C3C] flex items-center justify-center mx-auto mb-6">
                <XCircle size={48} weight="fill" className="text-white" />
              </div>
              <h1 className="text-2xl font-bold text-[#E74C3C] mb-4">Certificado Não Encontrado</h1>
              <p className="text-[#5C6B7A]">
                O certificado com este código de verificação não foi encontrado ou é inválido.
              </p>
            </>
          )}

          <Link to="/" className="inline-block mt-8">
            <button className="text-[#2C3E50] hover:underline font-medium">
              Voltar para a Página Inicial
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VerifyCertificate;
